/**
 * Convert number of bytes into human readable format.
 *
 * @module eval.space
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @author Yaroslav Surilov <y.surilov@infomir.com>
 */

'use strict';


/**
 * Convert number of bytes into human readable format with some precision.
 *
 * @param {number} bytes - number of bytes to convert
 * @param {number} [precision] - number of digits after the decimal separator
 *
 * @return {string} converted view
 */
function bytesToSize ( bytes, precision ) {
    var kilobyte = 1024,
        megabyte = kilobyte * 1024,
        gigabyte = megabyte * 1024,
        terabyte = gigabyte * 1024;

    if ( !precision ) {
        precision = 1;
    }

    if ( (bytes >= 0) && (bytes < kilobyte) ) {
        return bytes + ' B';
    } else if ( (bytes >= kilobyte) && (bytes < megabyte) ) {
        return (bytes / kilobyte).toFixed(precision) + ' KB';
    } else if ( (bytes >= megabyte) && (bytes < gigabyte) ) {
        return (bytes / megabyte).toFixed(precision) + ' MB';
    } else if ( (bytes >= gigabyte) && (bytes < terabyte) ) {
        return (bytes / gigabyte).toFixed(precision) + ' GB';
    } else if ( bytes >= terabyte ) {
        return (bytes / terabyte).toFixed(precision) + ' TB';
    }

    return bytes + ' B';
}


module.exports = bytesToSize;
